// extracted by mini-css-extract-plugin
export default {"table":"overviesStyles_table__RKWOP","row":"overviesStyles_row__3AXAl","col":"overviesStyles_col__rdZjK"};